import type { ProductImageEntry } from "./types";

/** Copy for the client and employee standing-data captures. */
export const RESOURCE_DETAIL_CATALOGUE: readonly ProductImageEntry[] = [
  {
    id: "standing-data.clients-list",
    module: "Kunder",
    area: "standing-data",
    opens: "Resurser → enhet → Kunder",
    setup: ["Öppna kundlistan för den syntetiska enheten"],
    scenario: "S5",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Kundlista för en vald enhet",
        shows: "Kundregistret visar kunderna som hör till den valda enheten.",
        proves: "Listan samlar kundernas grunddata för den valda enheten.",
      },
      en: {
        alt: "Client list for a selected service area",
        shows:
          "The client register lists clients belonging to the selected service area.",
        proves:
          "The list brings together client records for the selected service area.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "standing-data.client-basics",
    module: "Kunduppgifter",
    area: "standing-data",
    opens: "Resurser → kund → Grunddata",
    setup: ["Öppna en befintlig kunds grunddata"],
    scenario: "S5",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Kundens grunduppgifter i en skrivskyddad vy",
        shows:
          "Grunddata samlar kundens identitet, kontakt, ansvarig vårdgivare och adress.",
        proves:
          "Kundvyn gör befintliga uppgifter tillgängliga för granskning före redigering.",
      },
      en: {
        alt: "Client basics in a read-only view",
        shows:
          "Basic details bring together the client's identity, contact, designated caregiver and address.",
        proves:
          "The client view makes existing details available for review before editing.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "standing-data.client-advanced",
    module: "Kundens planeringsuppgifter",
    area: "standing-data",
    opens: "Resurser → kund → Avancerat",
    setup: ["Öppna kundens avancerade uppgifter"],
    scenario: "S5",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Kundens kontinuitetsmål och ärvda planeringsinställningar",
        shows:
          "Den avancerade vyn samlar kontinuitetsmål, prioritet och lokala överstyringar.",
        proves:
          "Vyn visar kundens planeringsuppgifter och hur lokala inställningar presenteras.",
      },
      en: {
        alt: "Client continuity target and inherited planning settings",
        shows:
          "The advanced view brings together continuity target, priority and local overrides.",
        proves:
          "The view shows the client's planning details and how local settings are presented.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "standing-data.employees-list",
    module: "Medarbetare",
    area: "standing-data",
    opens: "Resurser → enhet → Medarbetare",
    setup: ["Öppna medarbetarlistan för den syntetiska enheten"],
    scenario: "S5",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Medarbetarlista för en vald enhet",
        shows:
          "Medarbetarregistret visar personalen som hör till den valda enheten.",
        proves:
          "Listan samlar medarbetarnas grunddata inom enhetens sammanhang.",
      },
      en: {
        alt: "Employee list for a selected service area",
        shows:
          "The employee register lists staff belonging to the selected service area.",
        proves:
          "The list brings together employee records in the service area's context.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "standing-data.employee-basics",
    module: "Medarbetaruppgifter",
    area: "standing-data",
    opens: "Resurser → medarbetare → Grunddata",
    setup: ["Öppna en befintlig medarbetares grunddata"],
    scenario: "S5",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Medarbetarens grunduppgifter i en skrivskyddad vy",
        shows:
          "Grunddata samlar identitet, enhet, kontakt, anställning och kompetenser.",
        proves:
          "Medarbetarvyn gör befintliga uppgifter tillgängliga för granskning före redigering.",
      },
      en: {
        alt: "Employee basics in a read-only view",
        shows:
          "Basic details bring together identity, service area, contact, employment and skills.",
        proves:
          "The employee view makes existing details available for review before editing.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
  {
    id: "standing-data.employee-weekly-pattern",
    module: "Medarbetarens veckoschema",
    area: "standing-data",
    opens: "Resurser → medarbetare → Avancerat → Veckoschema",
    setup: ["Öppna medarbetarens avancerade uppgifter"],
    scenario: "S5",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Medarbetarens stående veckoschema och arbetstid",
        shows:
          "Veckoschemat visar ordinarie arbetspass och sammanfattad arbetstid.",
        proves:
          "Medarbetarens stående veckomönster visas tillsammans med arbetstidssammanfattningen.",
      },
      en: {
        alt: "Employee standing weekly pattern and hours",
        shows:
          "The weekly schedule shows ordinary shifts and a summary of working hours.",
        proves:
          "The employee's standing weekly pattern appears with its working-hours summary.",
      },
    },
    use: ["pages/Plattform.tsx"],
  },
];
